export const AGORA_APP_ID = '642e36d2f6d741ab885a6350306f7401'


// WEBPACK FOOTER //
// ./src/agora.config.js